export const GET_CONTRACTS_BEGIN = "GET_CONTRACTS_BEGIN";
export const GET_CONTRACTS_SUCCESS = "GET_CONTRACTS_SUCCESS";
export const GET_CONTRACTS_ERROR = "GET_CONTRACTS_ERROR";

export const GET_CONTRACT_BEGIN = "GET_CONTRACT_BEGIN";
export const GET_CONTRACT_SUCCESS = "GET_CONTRACT_SUCCESS";
export const GET_CONTRACT_ERROR = "GET_CONTRACT_ERROR";

export const OPT_IN_BEGIN = "OPT_IN_BEGIN";
export const OPT_IN_SUCCESS = "OPT_IN_SUCCESS";
export const OPT_IN_ERROR = "OPT_IN_ERROR";
